import { render, staticRenderFns } from "./apresentacaoDoExercicio.vue?vue&type=template&id=5fe5f22c&"
import script from "./apresentacaoDoExercicio.vue?vue&type=script&lang=js&"
export * from "./apresentacaoDoExercicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports